export class Color {
    private _hexaValue!: string;

    constructor(value = '#ffffff') {
        let v = typeof value === 'string' ? value.trim() : String(value);
        if (this.isRgba(v)) {
            v = this.rgbaToHexa(v);
        } else if (this.isRgb(v)) {
            v = this.rgbToHexa(v);
        }
        if (this.isHexa3(v)) {
            v = this.expandHex3(v);
        }
        this.assertIsHexa(v);
        this._hexaValue = v;
    }

    /** Pour les fills Fabric (SVG) : retourne un #hex normalisé ou null si non géré. */
    static normalizeFillToHex(fill: string): string | null {
        try {
            return new Color(fill).hexaValue;
        } catch {
            return null;
        }
    }

    rgbToHexa(rgb: string) {
        const rgbArray = rgb.match(/^rgb\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*\)$/i);
        if (!rgbArray) {
            throw new Error('Not rgb');
        }
        return this.componentsToHex(
            Math.round(parseFloat(rgbArray[1])),
            Math.round(parseFloat(rgbArray[2])),
            Math.round(parseFloat(rgbArray[3]))
        );
    }

    rgbaToHexa(rgba: string) {
        const m = rgba.match(/^rgba\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*\)$/i);
        if (!m) {
            throw new Error('Not rgba');
        }
        const r = Math.round(parseFloat(m[1]));
        const g = Math.round(parseFloat(m[2]));
        const b = Math.round(parseFloat(m[3]));
        const a = Math.min(1, Math.max(0, parseFloat(m[4])));
        const blend = (c: number) => Math.round(c * a + 255 * (1 - a));
        return this.componentsToHex(blend(r), blend(g), blend(b));
    }

    private componentsToHex(r: number, g: number, b: number) {
        const clamp = (n: number) => Math.max(0, Math.min(255, n));
        return (
            '#' +
            ('0' + clamp(r).toString(16)).slice(-2) +
            ('0' + clamp(g).toString(16)).slice(-2) +
            ('0' + clamp(b).toString(16)).slice(-2)
        );
    }

    isRgb(value: string) {
        return /^rgb\(\s*[\d.]+\s*,\s*[\d.]+\s*,\s*[\d.]+\s*\)$/i.test(value);
    }

    isRgba(value: string) {
        return /^rgba\(\s*[\d.]+\s*,\s*[\d.]+\s*,\s*[\d.]+\s*,\s*[\d.]+\s*\)$/i.test(value);
    }

    isHexa3(value: string) {
        return /^#[0-9A-F]{3}$/i.test(value);
    }

    expandHex3(shortHex: string) {
        const h = shortHex.slice(1);
        return ('#' + h[0] + h[0] + h[1] + h[1] + h[2] + h[2]).toUpperCase();
    }

    assertIsHexa(value: string) {
        if (!this.isHexa(value)) {
            throw new Error('Wrong color value');
        }
    }

    isHexa(value: string) {
        return /^#[0-9A-F]{8}$/i.test(value) || /^#[0-9A-F]{6}$/i.test(value) || /^#[0-9A-F]{3}$/i.test(value);
    }

    get hexaValue() {
        return this._hexaValue;
    }
}
